<div class="header-actions">

  <a class="link-cart" [routerLink]="'/home/cart'">
    <span class="material-icons icon-header">shopping_cart</span>
    <span class="hidden-xs">CARRITO</span>
    @if (cartItemCount > 0) {
      <span class="cart_qty_cls">{{cartItemCount}}</span>
    }
  </a>

  <app-topbar></app-topbar>

</div>

@if (show) {
  <div id="search-overlay" class="search-overlay" [ngStyle]="{ 'display': 'block' }">
    <div>
      <span class="closebtn" title="Close Overlay" (click)="closeSearch()">×</span>
      <div class="overlay-content">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <form>
                <div class="form-group">
                  <input type="text" class="form-control" id="inputSearch" placeholder="{{'search' | translate}}"
                    [(ngModel)]="articleFilter.articleFind" name="inputSearch">
                </div>
                <button type="submit" class="btn btn-primary" (click)="find()"><i class="fa fa-search"></i></button>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 button-clean">
              <a (click)="clean()" class="btn btn-solid">{{'search-clean' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
